import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import { useState } from 'react';

import CheckPermissions from '@/components/CheckPermissions';
import { PERMISSIONS } from '@/constants/auth.constants';

import type { TicketAssigneeProps } from './TicketAssignee.types';

export const TicketAssignee = ({
  onChange,
  assigneeOptions,
  assignee
}: TicketAssigneeProps) => {
  // Optimistic selection, valid only until the assignee prop changes
  const [draft, setDraft] = useState<{
    base: TicketAssigneeProps['assignee'];
    id: string;
  } | null>(null);
  const selectedId =
    draft && draft.base === assignee ? draft.id : `${assignee?.id ?? ''}`;

  const handleSelect = (event: SelectChangeEvent) => {
    const newSelectedId = event.target.value;
    setDraft({ base: assignee, id: newSelectedId });

    if (newSelectedId) {
      // Convert string to number
      const numericId = +newSelectedId;
      onChange?.(numericId);
    } else {
      onChange?.(null);
    }
  };

  return (
    <CheckPermissions permissions={[PERMISSIONS.TICKETS_UPDATE]}>
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <Select
            labelId="assignee-select-label"
            id="assignee-select"
            value={selectedId}
            onChange={handleSelect}
          >
            <MenuItem value="">
              <em>No Assignee</em>
            </MenuItem>
            {assigneeOptions.map((option) => (
              <MenuItem key={option.id} value={`${option.id}`}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </CheckPermissions>
  );
};

TicketAssignee.displayName = 'TicketAssignee';

export default TicketAssignee;
